import { Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";

import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { CenteredLazyLoading } from "@/controls/LazyLoading";

import { ShiftReportHeat } from "@/pages/shift-report/models/ShiftReportResponse";
import { backgroundColor } from "@/utils/theme";
import { RowClassParams, RowStyle } from "ag-grid-community";
import { useTableData } from "./useTableData";

export const TableHeats = ({
	heats,
	hoveredHeatId,
	onHeatHover,
	hiddenColumns,
}: {
	heats: ShiftReportHeat[];
	hoveredHeatId: number | null;
	onHeatHover?: (heatId: number | null) => void;
	hiddenColumns?: string[];
}) => {
	const { columnDefs } = useTableData(hiddenColumns);
	const { defaultColDef } = useGridDefinitions({});

	const getRowStyle = (
		params: RowClassParams<ShiftReportHeat, any>,
	): RowStyle | undefined => {
		const campaign = params.data;
		if (!campaign) return undefined;

		if (campaign.HeatId == hoveredHeatId)
			return { backgroundColor: backgroundColor };

		return undefined;
	};

	return (
		<>
			<Paper
				elevation={2}
				sx={{
					height: "100%",
					width: "100%",
					"& .ag-cell": {
						fontSize: 11,
					},
					"& .heat-cell": {
						paddingLeft: "2.5rem !important",
						display: "flex",
						alignItems: "center",
					},
				}}
			>
				<AgGridReact<ShiftReportHeat>
					rowData={heats || []}
					columnDefs={columnDefs}
					defaultColDef={defaultColDef}
					rowHeight={30}
					headerHeight={34}
					animateRows
					getRowId={(params) => String(params.data.CampaignId)}
					getRowStyle={getRowStyle}
					loadingOverlayComponent={CenteredLazyLoading}
					onCellMouseOver={(e) => onHeatHover?.(e.data?.HeatId ?? null)}
					onCellMouseOut={() => onHeatHover?.(null)}
				/>
			</Paper>
		</>
	);
};
